import React from 'react';

function ContactForm() {
  return (
    <section id="contact-form" className="section-padding bg-dark">
      <div className="container text-center">
        <h2>Let's Scale Your Agentic Future</h2>
        <p>Ready to deploy cognitive, autonomous AI agents inside your operations? Get in touch with our engineers.</p>
        <form action="https://formspree.io/f/mgvnqvgn" method="post" id="contactForm" className="contact-form-elements">
          <input type="text" id="form-name" name="name" placeholder="Your Name" required />
          <input type="email" id="form-email" name="email" placeholder="Your Work Email" required />
          <input type="text" id="form-company" name="company" placeholder="Your Company" />
          <textarea id="form-message" name="message" placeholder="Describe the workflows you'd like to automate using autonomous agents..." required></textarea>
          <button type="submit" className="btn btn-primary">Request Agent Consultation</button>
        </form>
      </div>
    </section>
  );
}

export default ContactForm;
